import React, { useState, useContext, useEffect } from 'react'
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, InfoHeader, useFormatter } from 'src/mtska-frontend-app-component'
import { useDataProvider } from 'src/mtska-frontend-data-provider'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'src/mtska-frontend-app-scaffolding'
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks'
import JSONPretty from 'react-json-pretty'

const dataProviderName = 'campaigns/campaign'

const Create = (params) => {
    const { t } = useTranslation()
    const { formatDate } = useFormatter();
    const { close: closeDrawer } = useDrawer()
    const { userCapabilities, existingModules } = useContext(AppContext)
    const { item, save, loadOne, destroy, errorMessage, errors, saving, reloadCounter, doAction, uid } = useDataProvider(dataProviderName, params.multipart)
    const { modelName, createConfig: detailConfig } = existingModules[dataProviderName]

    const [localError, setLocalError] = useState()
    const [confirmDelete, setConfirmDelete] = useState()
    const [editing, setEditing] = useState(false)

    const [isStarted, setIsStarted] = useState(false);

    useEffect(() => {
        if (isStarted) return;

        loadOne(params.id ?? null);
    }, [isStarted, params.id])

    useEffect(() => {
        if (!item) return;
        if (isStarted) return;
        setIsStarted(true);
    }, [item])


    const handleSave = (data) => {
        // save({ ...data, filters: params.filters, canReloadCounter: false })
        //     .then((data) => params.handleClose(params.uid, data.item.data))
        //     .catch(() => console.error('catch handleSave'))
    }

    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t('Delete')}
                okcallable={() => { destroy && destroy(id); closeDrawer() }}
                kolabel={t('Cancel')}
                kocallable={() => setConfirmDelete(null)}
                title={t('Item elimination')}
            >
                {t('Are you sure to remove this element?')}
            </Confirm>
        )
    }

    const onProcessStepAction = (currentStep, stepTotal, actionInvoked, getValues) => {
        setLocalError()
        const values = getValues()

        //console.info('valueswCampaignId', values)
        console.info('steps', currentStep, stepTotal, actionInvoked)

        const step0Fields = detailConfig.steps[0].columns[0].tabs[0].fieldsets[0].fields
        const step1Fields = detailConfig.steps[1].columns[0].tabs[0].fieldsets[0].fields
        const step2Fields = detailConfig.steps[2].columns[0].tabs[0].fieldsets[0].fields
        const step3Fields = detailConfig.steps[3].columns[0].tabs[0].fieldsets[0].fields
        const step4Fields = detailConfig.steps[4].columns[0].tabs[0].fieldsets[0].fields

        step1Fields.selected_segments_ids.relation.selectionModel = values.selected_segments_ids;
        step2Fields.excluded_audience_leads_ids.relation.selectionModel = values.excluded_audience_leads_ids;
        step4Fields.excluded_outcomes_ids.relation.selectionModel = values.excluded_outcomes_ids;

        filterOutcomesTable(values, step4Fields);

        // da info a seleziona segmenti
        if (currentStep === 0 && actionInvoked === 1) {
            const stepValid = onValidateStepAction(currentStep, getValues)
            if (!stepValid) return false;
            // console.info('----- INVIO CAMPAGNA ', values);

            return new Promise((resolve, reject) => {
                doAction({
                    action: 'create',
                    model: 'campaigns/campaign',
                    data: values
                }).then(() => {
                    console.info('values.campaignLeads', values.campaignLeads, saving);
                    const campaignLeads = values.campaignLeads ?? [];

                    if (campaignLeads.length == 0) {
                        // se non ho ancora campaignLeads
                        resolve({});
                    } else if (values.campaignLeads.some(obj => !('operator_id' in obj))) {
                        // se qualche campaignLead non ha operatore assegnato
                        resolve({ goToStep: 3 });
                    } else {
                        // se tutte sono assegnate salto allo step 4
                        resolve({ goToStep: 4 });
                    }
                })
            });

            // return true;
        }
        // da seleziona segmenti a escludi lead
        else if (currentStep === 1 && actionInvoked === 1) {
            if (values.selected_segments_ids === null || values.selected_segments_ids === undefined || (Array.isArray(values.selected_segments_ids) && values.selected_segments_ids.length === 0)) {
                setLocalError(t('Select at least one segment'))
                return false
            } else {
                const otherFilters = { segments: [] }
                otherFilters.segments = values.selected_segments_ids.map((id) => {
                    return { id: id }
                })
                step2Fields.excluded_audience_leads_ids.relation.otherFilters = otherFilters

                return new Promise((resolve, reject) => {
                    doAction({
                        action: 'create',
                        model: 'campaigns/campaign',
                        data: values
                    }).then(() => {
                        resolve({});
                    })
                });
            }
        }
        //da esclusione lead a assegna operatore
        else if (currentStep === 2 && actionInvoked === 1) {
            const otherFilters = { segments: [] }
            otherFilters.segments = values.selected_segments_ids.map((id) => {
                return { id: id }
            })
            step3Fields.campaign_leads_ids.relation.campaignId = values.id;

            return new Promise((resolve, reject) => {
                doAction({
                    action: 'createFromSegments',
                    model: 'campaigns/campaign',
                    data: {
                        id: values.id,
                        selected_segments_ids: Array.isArray(values.selected_segments_ids)
                            ? values.selected_segments_ids.map(s => s.id ?? s._id ?? s)
                            : [values.selected_segments_ids.id ?? values.selected_segments_ids._id ?? values.selected_segments_ids],
                        excluded_audience_leads_ids: Array.isArray(values.excluded_audience_leads_ids)
                            ? values.excluded_audience_leads_ids.map(l => l.id ?? l._id ?? l)
                            : []
                    }
                }).then(() => {
                    resolve({});
                })
            });

        }
        //da seleziona operatore a esiti campagne
        else if (currentStep === 3 && actionInvoked === 1) {
            const hasMissingOperatorId = values.campaignLeads.some(obj => !obj.hasOwnProperty('operator_id'));

            if (hasMissingOperatorId) {
                setLocalError(t('Every lead must be assigned to an operator'));
                return false;
            }
        }
        //da esiti campagne a recap
        else if (currentStep === 4 && actionInvoked === 1) {


        }
        //da recap a conferma
        else if (currentStep === 5 && actionInvoked === 1) {
            return new Promise((resolve, reject) => {
                doAction({
                    action: 'create',
                    model: 'campaigns/campaign',
                    data: { ...values, editingstatus: values.editingstatus == 'campaign_new' ? 'campaign_draft' : values.editingstatus }
                }).then(() => {
                    resolve({});
                })
            });
        }
        //da conferma a chiusura
        else if (currentStep === 6 && actionInvoked === 1) {
            closeDrawer();
        }
        return true
    }

    const filterOutcomesTable = (values, step4Fields) => {
        if (!values.mode) return;
        const filterModel = {
            items: [
                {
                    field: 'mode',
                    operator: 'equals',
                    value: values.mode
                }
            ]
        }
        console.info('Detail CampaignManagement | cambio filtri', filterModel)

        step4Fields.excluded_outcomes_ids.filters = filterModel;
    }

    const onValidateStepAction = (currentStep, getValues) => {
        const values = getValues()
        const step = detailConfig.steps[currentStep]
        if (!step) return true
        let stepValid = true
        const errors = []
        step.columns.forEach(col => col.tabs.forEach(tab => tab.fieldsets.forEach(fs => {
            Object.entries(fs.fields).forEach(([key, field]) => {
                if (field.required && !values[key]) {
                    stepValid = false;
                    console.info('----TROVATO ERRORE IN', key, field)
                    errors.push(t(key))
                }
            })
        })))

        if (!stepValid) setLocalError(t('Complete all required fields before proceeding: ' + errors.join(',')))
        return stepValid
    }

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return (
        <>
            {detailConfig && (
                <DetailComponent
                    values={{
                        name: null,
                        type: null,
                        channel: "TLS",
                        editingstatus: 'campaign_new',
                        start_at: tomorrow,
                        end_at: null,
                        salesDisk: null,
                        selected_segments_ids: [],
                        excluded_audience_leads_ids: [],
                        excluded_outcomes_ids: [],
                        ...item?.data,
                    }}
                    modelName={modelName}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    alertMessage={localError}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                    title={item?.data?.name ?? t('New campaign')}
                    subtitle={(item?.data?.start_at ? formatDate(item?.data?.start_at) : '') + " " + (item?.data?.end_at ? formatDate(item?.data?.end_at) : '').trim()}
                    header={<InfoHeader view="campaign" item={item?.data} />}
                    rightButtons={[
                        <SplitButton
                            actions={[{
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: 'faTrash',
                                label: t('Delete'),
                                onClick: () => handleDelete(item.data.id)
                            }]}
                        />
                    ]}
                    onProcessStepAction={onProcessStepAction}
                    onValidateStepAction={onValidateStepAction}
                    {...params}
                />
            )}
            {confirmDelete}
        </>
    )
}

export default Create